const container = document.querySelector('.sharethis-inline-share-buttons');

const checkLoaded = function() {
    let buttons = container.querySelectorAll('.st-btn');

    if (buttons.length > 0) {
        buttons.forEach((button) => {
            button.setAttribute('tabindex', 0);
            button.setAttribute('role', 'link');
            let network = button.getAttribute('data-network');
            button.setAttribute('aria-label', `Open ${network} share window`);
            button.addEventListener('keyup', e => {
            if (e.keyCode == 13) {
                button.click();
            }
            });
        });
    }
    else {
        setTimeout(checkLoaded, 400);
    }
};

container && setTimeout(checkLoaded, 400);